import { useMemo } from 'react';
import { TableDefinition } from '~/Components/DataTable/DataTable.types';
import { IFitoList } from '~/Components/FitoList/FitoListUncontrolled/interfaces';
import { Route } from '~/Constants/Routes.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { useNavigation, useProvider } from '~/Hooks';
import { IVODVideo } from '~/Models/DTO/VideoOnDemand.models';
import { useVoDVideosListColumns } from './useVoDVideosListColumns';

export const useVoDVideosList = () => {
  const { currentProvider } = useProvider();
  const { navigate } = useNavigation();
  const { columnMap } = useVoDVideosListColumns();

  const defaultQuery = { providerId: currentProvider?.uuid || '' };
  const keyOfId: keyof IVODVideo = 'id';

  const settings = {
    search: true,
    rearrange: false,
    pagination: true,
    headerPagination: {
      skip: 0,
      take: 50,
    },
  };

  const handleAddButtonClick = () => {
    navigate(
      routeReplacer(Route.VIDEO_ON_DEMAND_CREATE, { domain: currentProvider?.domain || '' }),
    );
  };

  const createListItem: (item: IVODVideo) => IFitoList = (item: IVODVideo) => ({
    header: item?.name,
    subheader: !!item?.releaseDate ? new Date(item?.releaseDate).toDateString() : '',
    onClick: () => navigate(routeReplacer(Route.VIDEO_ON_DEMAND_EDIT, { id: item?.id })),
  });

  const setItemValues = (item: IVODVideo): IFitoList => createListItem(item);

  const tableDefinition: TableDefinition = useMemo(
    () => ({
      columns: [columnMap.name, columnMap.status, columnMap.uploadDate],
      config: { useSelectableRows: true, usePagination: false },
    }),
    [columnMap],
  );

  return {
    defaultQuery,
    keyOfId,
    settings,
    setItemValues,
    tableDefinition,
    handleAddButtonClick,
    columnMap,
  };
};
